import React from "react";
import { IconProps } from "@/components/Icon";
interface FeaturedOutlineIconProps extends Omit<IconProps, "children"> {}

export const FeaturedOutlineIcon = ({ ...props }: FeaturedOutlineIconProps) => {
  return (
    <svg
      width="38px"
      height="38px"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.3">
        <rect
          x="6"
          y="6"
          width="26"
          height="26"
          rx="13"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
      <g opacity="0.1">
        <rect
          x="1"
          y="1"
          width="36"
          height="36"
          rx="18"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
      <g clip-path="url(#clip0_19673_63272)">
        <path
          d="M13.1084 13.1084L24.8917 24.8917M27.3334 19C27.3334 23.6024 23.6024 27.3334 19 27.3334C14.3976 27.3334 10.6667 23.6024 10.6667 19C10.6667 14.3976 14.3976 10.6667 19 10.6667C23.6024 10.6667 27.3334 14.3976 27.3334 19Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_19673_63272">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(9 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
